{
    "filter_menu_title__status": "Statut",
    "filter_menu_title__order_date": "Date de commande",
    "filter_menu_title__quote_date": "Date du devis",
    "filter_menu_title__clerk": "Saisi par",
    "filter_menu_title__order_type": "Type de commande",
    "filter_menu_title__quote_type": "Type de devis",
    "filter_menu_title__sales_rep": "Commercial",
    "filter_menu_title__location": "Entrepôt",
    "filter_menu_title__total_amount_net": "Total",
    "filter_menu_title__total_margin": "Marge",
    "table_header__product_name": "Article",
    "table_header__quote_id": "N° devis",
    "table_header__order_id": "N° commande",
    "table_header__quote_type": "Type de devis",
    "table_header__order_type": "Type de commande",
    "table_header__customer_id": "N° client",
    "table_header__quote_created": "Date",
    "table_header__order_created": "Date",
    "table_header__status": "Statut",
    "table_header__customer": "Client",
    "table_header__total": "Total",
    "table_header__rebate": "Remise",
    "table_header__margin": "Marge",
    "table_header__margin_percent": "Marge %",
    "table_header__lines": "Lignes",
    "table_header__quantity": "Quantité livrée",
    "table_header__quantity_short": "Quantité",
    "table_header__price": "Prix",
    "table_header__clerk": "Saisi par",
    "table_header__po_number": "N° de commande client",
    "search_placeholder__orders": "Rechercher client, commande, référence",
    "search_placeholder__quotes": "Rechercher client, devis, référence",
    "table_footer__sum": "Somme"
}
